module.exports = __webpack_public_path__ + "media/flags/gq-6579b4b1.svg";